import 'leaflet.markercluster'
import 'leaflet.markercluster/dist/MarkerCluster.css'
import 'leaflet.markercluster/dist/MarkerCluster.Default.css'

import {
  createPathComponent,
  LeafletContextInterface,
} from '@react-leaflet/core'
import L, { MarkerClusterGroupOptions } from 'leaflet'
import { ReactNode, useEffect } from 'react'

interface MarkerClusterProps extends MarkerClusterGroupOptions {
  children?: ReactNode
  onClusterclick?: () => void
  onClusteradd?: () => void
  onClusterremove?: () => void
  onClustermouseover?: () => void
}

export const MarkerCluster = createPathComponent<
  L.MarkerClusterGroup,
  MarkerClusterProps
>(
  (
    { children: _, ...props }: MarkerClusterProps,
    context: LeafletContextInterface,
  ) => {
    const { clusterProps, clusterEvents } = Object.entries(props).reduce(
      (acc, [propName, prop]) => {
        if (propName.startsWith('on')) {
          acc.clusterEvents[propName] = prop
        } else {
          acc.clusterProps[propName] = prop
        }

        return acc
      },
      {
        clusterProps: {} as Record<string, any>,
        clusterEvents: {} as Record<string, any>,
      },
    )

    const markerClusterGroup = new L.MarkerClusterGroup(clusterProps)

    Object.entries(clusterEvents).forEach(([eventAsProp, callback]) => {
      const clusterEvent = `cluster${eventAsProp.substring(2).toLowerCase()}`
      markerClusterGroup.on(clusterEvent, callback)
    })

    useEffect(() => {
      if (context.map.getMaxZoom() === Infinity) {
        context.map.setMaxZoom(23)
      }
    }, [])

    _ // discard children
    return {
      instance: markerClusterGroup,
      context: {
        ...context,
        layerContainer: markerClusterGroup,
      },
    }
  },
)
